module.exports = __webpack_public_path__ + "static/media/edit-icon.373c7bb4.svg";